import React from 'react';
import createSvgIcon from '@mui/icons-material/utils/createSvgIcon';
import { styled } from '../styled';
import parseColor from '../util/parseColor';
import { createMmmTheme } from '../Theme';

const Icon = createSvgIcon(
  <svg viewBox='0 0 51 51' fill='none' color='inherit' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M17.7729 48.4562L13.3887 41.0724L5.08195 39.2265L5.88956 30.689L0.236328 24.2281L5.88956 17.7673L5.08195 9.22976L13.3887 7.38381L17.7729 0L25.6182 3.34579L33.4635 0L37.8476 7.38381L46.1544 9.22976L45.3468 17.7673L51 24.2281L45.3468 30.689L46.1544 39.2265L37.8476 41.0724L33.4635 48.4562L25.6182 45.1105L17.7729 48.4562ZM19.7342 42.5723L25.6182 40.0341L31.6175 42.5723L34.8479 37.0344L41.1934 35.5346L40.6165 29.0737L44.8853 24.2281L40.6165 19.2671L41.1934 12.8063L34.8479 11.4218L31.5021 5.88397L25.6182 8.42216L19.6188 5.88397L16.3884 11.4218L10.0429 12.8063L10.6198 19.2671L6.35104 24.2281L10.6198 29.0737L10.0429 35.6499L16.3884 37.0344L19.7342 42.5723Z'
      fill='var(--verified-multicolor-colors-check)'
    />
    <path
      d='M22.4961 32.4194L35.5331 19.3824L32.3027 16.0366L22.4961 25.8432L17.5351 20.9976L14.3047 24.228L22.4961 32.4194Z'
      fill='var(--verified-multicolor-colors-spikes)'
    />
  </svg>,
  'VerifiedMulticolor',
);

const greenTheme = createMmmTheme({ mode: 'light', colors: 'default' });

export const defaultColors = {
  check: greenTheme.palette.primary.light,
  spikes: greenTheme.palette.pink.dark,
};

const ColoredIcon = styled(Icon, {
  shouldForwardProp: (p) => p !== 'colors',
})(({ theme, colors: overrideColors = {} }) => {
  const colors = {
    ...defaultColors,
    ...overrideColors,
  };
  return ({
    '--verified-multicolor-colors-check': parseColor(theme, colors.check),
    '--verified-multicolor-colors-spikes': parseColor(theme, colors.spikes),
  });
});

export default ColoredIcon;
